exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".td-word-break[data-v-eba327fe] {\n  word-wrap: break-word;\n  white-space: normal;\n}", ""]);

// exports
